import useFlag from './useFlag';

const FLAG = 'consumer-experience.time-slots-durations';

export function useTimeSlotsV2DurationsEnabled() {
  const isEnabled = useFlag<boolean>(FLAG, false);

  return Boolean(isEnabled);
}
